"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.staticRenderFns = exports.render = void 0;
var render = exports.render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("page", {
    attrs: {
      "return-menu": "/farm-management/dashboard",
      menu: _vm.page.children,
      subtitle: _vm.page.meta.title
    }
  }, [_c("template", {
    slot: "context"
  }, [_c("h1", [_vm._v("Dashboard")]), _vm._v(" "), _c("div", {
    staticClass: "header-bar"
  }, [_c("b-field", {
    attrs: {
      label: "Filtrar por pontos:"
    }
  }, [_c("b-select", {
    attrs: {
      expanded: ""
    },
    on: {
      input: _vm.onFilterChange
    },
    model: {
      value: _vm.filters.period,
      callback: function callback($$v) {
        _vm.$set(_vm.filters, "period", $$v);
      },
      expression: "filters.period"
    }
  }, [_c("option", {
    attrs: {
      value: "all"
    }
  }, [_vm._v("\n            Todos\n          ")]), _vm._v(" "), _c("option", {
    attrs: {
      value: "week"
    }
  }, [_vm._v("\n            Semanais\n          ")]), _vm._v(" "), _c("option", {
    attrs: {
      value: "month"
    }
  }, [_vm._v("\n            Mensais\n          ")]), _vm._v(" "), _c("option", {
    attrs: {
      value: "year"
    }
  }, [_vm._v("\n            Anuais\n          ")])])], 1)], 1), _vm._v(" "), _c("div", {
    staticClass: "dashboard-grid"
  }, [_c("section", {
    staticClass: "card"
  }, [_c("header", {
    staticClass: "card-header"
  }, [_c("p", {
    staticClass: "card-header-title"
  }, [_vm._v("\n            Maiores saldos negativos\n          ")])]), _vm._v(" "), _c("div", {
    staticClass: "card-content"
  }, [_c("b-table", {
    attrs: {
      data: _vm.topNegative,
      loading: _vm.isLoading.negative,
      "mobile-cards": true,
      paginated: false,
      striped: "",
      hoverable: ""
    }
  }, [_c("b-table-column", {
    attrs: {
      field: "user",
      label: "Colaborador"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(props) {
        var _props$row$user, _props$row$user2, _props$row$user3;
        return [_c("div", {
          staticClass: "user-cell"
        }, [(_props$row$user = props.row.user) !== null && _props$row$user !== void 0 && _props$row$user.imageUrl ? _c("img", {
          staticClass: "avatar",
          attrs: {
            src: props.row.user.imageUrl,
            alt: "avatar"
          }
        }) : _vm._e(), _vm._v(" "), _c("span", [_vm._v(_vm._s((_props$row$user2 = props.row.user) === null || _props$row$user2 === void 0 ? void 0 : _props$row$user2.firstName) + " " + _vm._s((_props$row$user3 = props.row.user) === null || _props$row$user3 === void 0 ? void 0 : _props$row$user3.lastName))])])];
      }
    }])
  }), _vm._v(" "), _c("b-table-column", {
    attrs: {
      field: "balance",
      label: "Saldo"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(props) {
        return [_c("span", {
          class: {
            neg: props.row.balance < 0,
            pos: props.row.balance > 0
          }
        }, [_vm._v("\n                " + _vm._s(_vm.formatSeconds(props.row.balance)) + "\n              ")])];
      }
    }])
  }), _vm._v(" "), _c("b-table-column", {
    attrs: {
      field: "worked",
      label: "Trabalhadas"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(props) {
        return [_vm._v("\n              " + _vm._s(_vm.formatSeconds(props.row.totalWorkedSeconds)) + "\n            ")];
      }
    }])
  }), _vm._v(" "), _c("b-table-column", {
    attrs: {
      field: "regular",
      label: "Regulares"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(props) {
        return [_vm._v("\n              " + _vm._s(_vm.formatSeconds(props.row.regularSeconds)) + "\n            ")];
      }
    }])
  })], 1)], 1)]), _vm._v(" "), _c("section", {
    staticClass: "card"
  }, [_c("header", {
    staticClass: "card-header"
  }, [_c("p", {
    staticClass: "card-header-title"
  }, [_vm._v("\n            Maiores saldos positivos\n          ")])]), _vm._v(" "), _c("div", {
    staticClass: "card-content"
  }, [_c("b-table", {
    attrs: {
      data: _vm.topPositive,
      loading: _vm.isLoading.positive,
      "mobile-cards": true,
      paginated: false,
      striped: "",
      hoverable: ""
    }
  }, [_c("b-table-column", {
    attrs: {
      field: "user",
      label: "Colaborador"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(props) {
        var _props$row$user4, _props$row$user5, _props$row$user6;
        return [_c("div", {
          staticClass: "user-cell"
        }, [(_props$row$user4 = props.row.user) !== null && _props$row$user4 !== void 0 && _props$row$user4.imageUrl ? _c("img", {
          staticClass: "avatar",
          attrs: {
            src: props.row.user.imageUrl,
            alt: "avatar"
          }
        }) : _vm._e(), _vm._v(" "), _c("span", [_vm._v(_vm._s((_props$row$user5 = props.row.user) === null || _props$row$user5 === void 0 ? void 0 : _props$row$user5.firstName) + " " + _vm._s((_props$row$user6 = props.row.user) === null || _props$row$user6 === void 0 ? void 0 : _props$row$user6.lastName))])])];
      }
    }])
  }), _vm._v(" "), _c("b-table-column", {
    attrs: {
      field: "balance",
      label: "Saldo"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(props) {
        return [_c("span", {
          class: {
            neg: props.row.balance < 0,
            pos: props.row.balance > 0
          }
        }, [_vm._v("\n                " + _vm._s(_vm.formatSeconds(props.row.balance)) + "\n              ")])];
      }
    }])
  }), _vm._v(" "), _c("b-table-column", {
    attrs: {
      field: "worked",
      label: "Trabalhadas"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(props) {
        return [_vm._v("\n              " + _vm._s(_vm.formatSeconds(props.row.totalWorkedSeconds)) + "\n            ")];
      }
    }])
  }), _vm._v(" "), _c("b-table-column", {
    attrs: {
      field: "regular",
      label: "Regulares"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(props) {
        return [_vm._v("\n              " + _vm._s(_vm.formatSeconds(props.row.regularSeconds)) + "\n            ")];
      }
    }])
  })], 1)], 1)]), _vm._v(" "), _c("section", {
    staticClass: "card chart-card"
  }, [_c("header", {
    staticClass: "card-header"
  }, [_c("p", {
    staticClass: "card-header-title"
  }, [_vm._v("\n            Saldo por mês\n          ")])]), _vm._v(" "), _c("div", {
    staticClass: "card-content"
  }, [_c("canvas", {
    ref: "monthChart",
    attrs: {
      height: "420"
    }
  })])])])])], 2);
};
var staticRenderFns = exports.staticRenderFns = [];
render._withStripped = true;